import { createAction, props } from '@ngrx/store';

import { Taxonomy } from '@core/models/taxonomy.model';

export const locationsNestedCollectionAddMany = createAction(
  '[STORED LOCATIONS NESTED - ADD MANY] Locations Nested collection add many.',
  props<{ locationsNested: Taxonomy[] }>()
);
